<component
  v-if="disabled"
  :is="cType"
  :class="[className(cClass), cClass, 'btn-pipple-handler c-child']"
  @click="emitHandler"
  ref="pippleButton"
  @dbl.stop
>
  {{ $t(cValue) }}
</component>
<component
  v-else-if="!loading"
  :is="cType"
  :class="[cClass, 'c-child', 'btn-pipple-handler']"
  @click="handler"
  ref="pippleButton"
  @dbl.stop
>
  <slot name="image" :row="icon"></slot>
  <slot name="icon"></slot>
  {{ $t(cValue) }}
</component>
<component
  v-else
  :is="cType"
  :class="[cClass, className(cClass), 'btn-pipple-handler c-child']"
  @click="emitHandler"
  ref="pippleButton"
  @dbl.stop
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 100 100"
  >
    <circle
      cx="50"
      cy="50"
      fill="none"
      stroke="var(--primary)"
      stroke-width="6"
      r="35"
      stroke-dasharray="164.93361431346415 56.97787143782138"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        repeatCount="indefinite"
        dur="1s"
        keyTimes="0;1"
        values="0 50 50;360 50 50"
      ></animateTransform>
    </circle>
  </svg>
</component>
